import { defineMessages } from 'react-intl';

export default defineMessages({
    saveTimeAndPaper: {
        id: 'wmic.components.EmailConsentPage.Save time and paper',
        defaultMessage: 'Preferred Method of Contact'
    },
    submit: {
        id: 'wmic.components.EmailConsentPage.submit',
        defaultMessage: 'Submit'
    },
    setContactPreference: {
        id: 'wmic.components.EmailConsentPage.Set Your Contact Preference',
        defaultMessage: 'Set Your Contact Preference'
    },
    consentParagraph: {
        id: 'wmic.components.EmailConsentPage.consentParagraph',
        defaultMessage: 'With your consent, W\u00A0Insurance will electronically deliver your policy documents, forms, endorsements, billing statements, notices, claim-related documents, and any other documents and communications permitted or required by law. Your consent is voluntary. You can email us at &lt;a href="mailto:service@w-insurance.com"&gt;service@w-insurance.com&lt;/a&gt; or call us at &lt;a href="tel:800-640-2920"&gt;800.640.2920&lt;/a&gt; to opt-out of receiving electronic delivery of your documents at any time, to update your email address to ensure you receive all communications or request free paper copies of your documents. Please note that to receive these documents electronically, you need to have internet access, an active email account, an active online account through the W\u00A0Insurance website, and the ability to open attachments, such as pdf files. By selecting electronic delivery, you understand and agree that we may provide you an e-mail with a link to our website when a Communication is available to view, print and save. It is your responsibility to view your Communications by logging onto your online account at &lt;a href="https://w-insurance.com/"&gt;w-insurance.com&lt;/a&gt; using your username and password that you created to access this website. Certain Communications may be available online only for a limited time period. We may also send you Communications directly by e-mail. You agree that the foregoing electronic process constitutes delivery of the Communications to you in a form that you can retain and will have the same force and effect as if the Communications were sent to you in paper form.'
    },
    consentQuestion: {
        id: 'wmic.components.EmailConsentPage.consentQuestion',
        defaultMessage: 'Would you like to receive your documents and communication electronically?'
    },
    consentYes: {
        id: 'wmic.components.EmailConsentPage.consentYes',
        defaultMessage: '&lt;strong&gt;Yes&lt;/strong&gt;- I want to receive my documents electronically. By clicking here, I confirm that I have read the information above and consent to the electronic delivery of documents and communications from W\u00A0Insurance which will be sent to {email}.'
    },
    consentNo: {
        id: 'wmic.components.EmailConsentPage.consentNo',
        defaultMessage: '&lt;strong&gt;No&lt;/strong&gt;- I do not want to receive my documents electronically and want to receive communications via US mail.'
    },
    privacyPolicy: {
        id: 'wmic.components.EmailConsentPage.Privacy Policy',
        defaultMessage: 'Privacy Policy '
    },
    termsofUse: {
        id: 'wmic.components.EmailConsentPage.Terms of Use',
        defaultMessage: 'Terms of Use '
    },
    onlinePaymentTerms: {
        id: 'wmic.components.EmailConsentPage.Online Payment Terms',
        defaultMessage: 'Online Payment Terms'
    },
    easyAccessHeading: {
        id: 'wmic.components.EmailConsentPage.Easy access',
        defaultMessage: 'Easy access to what &lt;span&gt;you&lt;/span&gt; need when &lt;span>you&lt;/span&gt; need it.'
    },
    digitalIDCards: {
        id: 'wmic.components.EmailConsentPage.Digital ID Cards',
        defaultMessage: 'Digital ID Cards'
    },
    roadsideAssistanceCards: {
        id: 'wmic.components.EmailConsentPage.Roadside Assistance Cards',
        defaultMessage: 'Roadside Assistance Cards'
    },
    makePaymentsQuicklyAndEasily: {
        id: 'wmic.components.EmailConsentPage.Make payments quickly and easily',
        defaultMessage: 'Make payments quickly and easily'
    },
    viewPolicyDetails: {
        id: 'wmic.components.EmailConsentPage.View policy details',
        defaultMessage: 'View policy details'
    },
    reviewPolicyRenewals: {
        id: 'wmic.components.EmailConsentPage.Review policy renewals',
        defaultMessage: 'Review policy renewals'
    },
    viewClaimsInformation: {
        id: 'wmic.components.EmailConsentPage.View claims information',
        defaultMessage: 'View claims information'
    },
    paymentPlanChanges: {
        id: 'wmic.components.EmailConsentPage.Payment plan changes',
        defaultMessage: 'Payment plan changes'
    },
    claimsPaymentHistory: {
        id: 'wmic.components.EmailConsentPage.Claims payment history',
        defaultMessage: 'Claims payment history'
    },
    makePolicyChanges: {
        id: 'wmic.components.EmailConsentPage.Make policy changes',
        defaultMessage: 'Make policy changes'
    }
});